// extracted by mini-css-extract-plugin
export default {"wrapper_content":"styles_wrapper_content__0N-PL","wrapper":"styles_wrapper__a2sIk","text":"styles_text__ZgNY7"};